import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { getCurrentUserId } from "store/user/user.reducer";

import styles from "../historyTable.module.scss";

const historyActionColumn = getRendererByKey => ({
	Header: "Action",
	accessor: "modifications",
	classNameHeader: styles.actionColHeader,
	disableSortBy: true,
	Cell: ({ cell, row }) => {
		const currentUserId = useSelector(getCurrentUserId);

		const allModifications = row?.original?.modifications;
		const cellModifications = cell?.value;
		const modificationUserId = row?.original?.created_by?.id;

		const allMessages = row?.original?.messages;

		const renderFields = () => {
			const fields: any = [];
			Object.keys(cellModifications).forEach((key, index) => {
				const renderField = getRendererByKey(key);
				if (renderField) {
					fields.push(
						renderField({
							index,
							allModifications,
							field_name: key,
							modificationUserId: modificationUserId,
							currentUserId: currentUserId,
							...cellModifications[key],
						}),
					);
				}
			});
			return fields;
		};

		const renderMessages = useMemo(
			() => (
				<ul className="list-unstyled p-0 m-0">
					{allMessages?.map((item, index) => (
						<li key={`${item.text}-${index}`}>{item.text}</li>
					))}
				</ul>
			),
			[allMessages],
		);

		return (
			<div className={`${styles.historyActionList} list-unstyled`}>
				{allMessages?.length > 0 ? renderMessages : renderFields()}
			</div>
		);
	},
});

export default historyActionColumn;
